import axios from "./axios";

import { downloadFile } from "./fileDownloader";

const bulkOrderValidateStatus = (status) => status >= 200 && status < 600;

export const sampleFile = () => {
    return downloadFile("/api/broker-gateway/bulk-order/");
}

export const uploadFile = async (payload) => {
    const formData = payload instanceof FormData ? payload : new FormData();
    formData.append("action", "upload");
    if (!(payload instanceof FormData) && payload && typeof payload === "object") {
        Object.entries(payload).forEach(([k, v]) => { if (k !== "action" && v != null) formData.append(k, v); });
    }
    const response = await axios.post("/api/broker-gateway/bulk-order/", formData, {
        validateStatus: bulkOrderValidateStatus,
    });
    return response;
}

export const getBulkOrders = async () => {

    const payload = { "action": "get" }

    const response = await axios.post("/api/broker-gateway/bulk-order/", payload);

    return response.data

}

export const getBulkOrderColumns = async () => {

    const response = await axios.get("/api/analytics/table-schema/bulk_order_columns/");

    return response.data

}

export const placeBulkOrders = async (orderList) => {

    const payload = { "order_list": orderList, "action": "place" }

    const response = await axios.post("/api/broker-gateway/bulk-order/", payload);

    return response.data

}

export function buildBulkModifyOrderItem(row) {
    const qtyRaw = row.order_quantity ?? row.order_lot ?? 0;
    const qtyNum = Number(qtyRaw);
    const orderQuantity = Number.isNaN(qtyNum) ? 0 : Math.max(0, Math.floor(qtyNum));
    const disclosedRaw = row.disclosed_quantity ?? 0;
    const disclosedNum = Number(disclosedRaw);
    const exchange = row.exchange ?? "NSE";
    const disclosedQuantity =
        exchange === "NFO"
            ? 0
            : Number.isNaN(disclosedNum)
              ? 0
              : Math.max(0, Math.floor(disclosedNum));
    const lotSize =
        Number.isNaN(Number(row.lot_size)) || Number(row.lot_size) <= 0 ? 1 : Number(row.lot_size);
    const bulkIdNum = Number(row.bulk_order_id);

    return {
        bulk_order_id: Number.isNaN(bulkIdNum) ? row.bulk_order_id : bulkIdNum,
        broker_client_code: row.broker_client_code ?? "",
        exchange,
        exchange_trading_symbol: row.exchange_trading_symbol ?? "",
        transaction_type: row.transaction_type ?? "BUY",
        order_type: row.order_type ?? "LIMIT",
        order_price: Number.isNaN(Number(row.order_price)) ? 0 : Number(row.order_price),
        trigger_price: Number.isNaN(Number(row.trigger_price)) ? 0 : Number(row.trigger_price),
        order_quantity: orderQuantity,
        disclosed_quantity: disclosedQuantity,
        product_type: row.product_type ?? "DELIVERY",
        lot_size: lotSize,
        validity: row.validity ?? "DAY",
    };
}

export const modifyBulkOrders = async (orderList) => {
    const payload = { order_list: orderList, action: "modify" };
    const response = await axios.post("/api/broker-gateway/bulk-order/", payload, {
        validateStatus: bulkOrderValidateStatus,
    });
    return response;
}

export const deleteBulkOrders = async (orderList) => {
    const payload = { order_list: orderList, action: "delete" };
    const response = await axios.post("/api/broker-gateway/bulk-order/", payload);
    return response.data;
}

export const getSliceOrders = async () => {

    const response = await axios.get("/api/broker-gateway/slice-order/");

    return response.data

}

export const getSweepOrders = async () => {

    const response = await axios.get("/api/broker-gateway/sweep-order/");

    return response.data

}

export const getSliceOrderColumns = async () => {

    const response = await axios.get("/api/analytics/table-schema/slice_order_columns/");

    return response.data

}

export const getSweepOrderColumns = async () => {

    const response = await axios.get("/api/analytics/table-schema/sweep_order_columns/");

    return response.data

}




export const cancelOpenOrders = async (orderList) => {

    const response = await axios.post("/api/broker-gateway/order-modification/", orderList);

    return response.data

}